import React, { useEffect, useState } from "react";
import { Container, Button, Form, Row, Col } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import "./ViewPage.css";
import axios from "axios";


const Privileges = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { emp_id } = useParams();
  const navigate = useNavigate();
  const [localPrivileges, setLocalPrivileges] = useState({});
  const [permissionKeys, setPermissionKeys] = useState([]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [previllage_id, setPrevillageId] = useState("");
  //  const email = localStorage.getItem("email");
  //   const userName = JSON.parse(localStorage.getItem('user_name'));

  useEffect(() => {
    axios.post(`${API_BASE_URL}previllage_detail.php`, { emp_id: emp_id })
      .then((response) => {
        if (response.data.head.code === 200) {
          const data = response.data.body;
          setName(data.name);
          setEmail(data.email);
          setPrevillageId(data.prev_id);
          // Remove unwanted keys
          const ignore = ["prev_id", "emp_id", "name", "email", "added_date", "added_time", "am_pm"];

          const keys = Object.keys(data).filter(k => !ignore.includes(k));

          // Convert "0"/"1" → boolean
          const temp = {};
          keys.forEach(key => {
            temp[key] = data[key] === "1";
          });

          setPermissionKeys(keys);
          setLocalPrivileges(temp);
        }
      })
      .catch((err) => console.log("API Error:", err));
  }, [emp_id]);

  const handleSave = () => {
    // console.log("testing start");
    axios.post(`${API_BASE_URL}previllage_detail_edit.php`,
      {
        prev_id: previllage_id,                 // required
        user: localPrivileges.user ? "1" : "0",
        department: localPrivileges.department ? "1" : "0",
        designation: localPrivileges.designation ? "1" : "0",
        working_hrs: localPrivileges.working_hrs ? "1" : "0",
        attendance: localPrivileges.attendance ? "1" : "0",
        leave_permission: localPrivileges.leave_permission ? "1" : "0",
        leave_status: localPrivileges.leave_status ? "1" : "0",
        task: localPrivileges.task ? "1" : "0",
        od: localPrivileges.od ? "1" : "0",
        od_status: localPrivileges.od_status ? "1" : "0",
        employee: localPrivileges.employee ? "1" : "0",
        salary_aided: localPrivileges.salary_aided ? "1" : "0",
        salary_sf: localPrivileges.salary_sf ? "1" : "0"
      }
    )
      .then((response) => {
        if (response.data.head.code === 200) {
          window.location.reload();
          // setEmployeeList(response.data.body);
          // setFilteredOrders(response.data.body);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          // setEmployeeList([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        // setEmployeeList([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  }


  const togglePrivilege = (key) => {
    setLocalPrivileges(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };


  const toggleAll = () => {
    const anyUnchecked = permissionKeys.some((p) => !localPrivileges[p]);

    const updated = permissionKeys.reduce((acc, key) => {
      acc[key] = anyUnchecked; // set all to true OR all to false
      return acc;
    }, {});

    setLocalPrivileges(updated);
  };

  const labelMap = {
    employee: "Manage Permission",
    salary_sf: "Salary Self Financing",
    working_hrs: "Working Hours",
  };


  return (
    <div className="outer-container">
      <Container className="my-4">
        {/* Header */}
        <div className="customer-header mb-3">
          <div>
            <h4 className="mb-0">Privileges for: {name}</h4>
            <small className="text-muted">{email}</small>
          </div>
          <div>
            <Button className="btn-top me-2" onClick={() => navigate("/settings")}>
              Back
            </Button>
            <Button className="btn-top me-2" onClick={toggleAll}>
              Toggle All
            </Button>
          </div>
        </div>

        {/* Privileges list */}
        <Row className="justify-content-center">
          <Col xs={12} lg={6}>
            <div className="customer-view-card">
              <div className="customer-details-table-wrapper">
                <table className="customer-view-table privileges-table">
                  <thead>
                    <tr>
                      <th className="permission-column">Permission</th>
                      <th className="allowed-column">Allowed</th>
                    </tr>
                  </thead>
                  <tbody>
                    {permissionKeys.map((perm) => (
                      <tr key={perm}>
                        <td className="field-cell permission-column">
                          {/* {perm.replace(/_/g, " ").toUpperCase()} */}
                          {(labelMap[perm] || perm.replace(/_/g, " ")).toUpperCase()}

                        </td>

                        <td className="value-cell allowed-column text-center">
                          <Form.Check
                            type="checkbox"
                            checked={!!localPrivileges[perm]}
                            onChange={() => togglePrivilege(perm)}
                            id={`priv-${perm}`}
                            aria-label={`Allow ${perm}`}
                            className="custom-checkbox"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>

                </table>
              </div>
              <div className="save-button-container">
                <Button className="btn-submit" onClick={() => handleSave()}>
                  Save
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Privileges;